import React from 'react';
import styles from './AccordionHeader.module.scss';

interface Props {
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
}

const AccordionContent = ({ children, className = '' }: Props) => {
  const classes = [styles.AccordionControls];
  if (className) classes.push(className);
  return <div className={classes.join(' ')}>{children}</div>;
};

export default AccordionContent;
